var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignScheduledNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20654_6026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66699V10.0003L11.25 11.2503",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2885 13.7111C17.6522 14.4475 18.334 14.8157 18.334 15.4166C18.334 16.0176 17.6522 16.3858 16.2885 17.1221L15.3599 17.6236C14.3127 18.1891 13.7891 18.4719 13.5373 18.2663C12.9207 17.7628 13.8812 16.4634 14.1176 16.0031C14.3571 15.5366 14.3527 15.2882 14.1176 14.8302C13.8812 14.3699 12.9207 13.0705 13.5373 12.567C13.7891 12.3614 14.3127 12.6441 15.3599 13.2096L16.2885 13.7111Z",
    stroke: "white",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8554 18.2903C10.5743 18.319 10.289 18.3337 10.0003 18.3337C5.39795 18.3337 1.66699 14.6027 1.66699 10.0003C1.66699 5.39795 5.39795 1.66699 10.0003 1.66699C14.6027 1.66699 18.3337 5.39795 18.3337 10.0003C18.3337 10.5711 18.2762 11.1285 18.167 11.667",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20654_6026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignScheduledNew);
export default __webpack_public_path__ + "static/media/campaignScheduledNew.4879580b4428c5d3d8b1d7c99e714dc3.svg";
export { ForwardRef as ReactComponent };